import http from './http';

export function getLanguages() {
	return http.get('/admin/languages').then(resp => resp.data.data);
}
